/**
 * Two-color impact printers (e.g. Epson TM-U220 at kitchen) use ESC r n for ink color.
 * @see printer.color() — \x1b\x72\x00 black, \x1b\x72\x01 red
 */

const KITCHEN_IMPACT_PRINTER_NAME = "kitchen";

function printerName (printer) {
  return (printer?.name || "").trim().toLowerCase();
}

/**
 * True when this printer is the kitchen TM-U220 (configured name: "Kitchen").
 */
export function isTm220uImpactPrinter (printer) {
  return printerName(printer) === KITCHEN_IMPACT_PRINTER_NAME;
}

/**
 * Red modifier lines on kitchen tickets when routed to the Kitchen impact printer.
 * Callers must also pass kitchen=true (see buildItemsPart / printKitchenReceiptTemplate2).
 */
export function shouldUseRedModifiers (_terminalInfo, printer) {
  return isTm220uImpactPrinter(printer);
}
